export default {
  FILE_TYPE: 'FILE_TYPE',
  FILE_SIZE: 'FILE_SIZE',
  DUPLICATED_ENTITY: 'DUPLICATED_ENTITY',
  VALIDATION: 'VALIDATION',
  OTHER: 'OTHER',
};
